import React from 'react';
import PropTypes from 'prop-types';

function VideoPlayer({ videoLink, errorMessage, CustomWrapper }) {
	const WrapperComponent = CustomWrapper || React.Fragment;

	return (
		<WrapperComponent>
			{videoLink ? (
				<iframe
					width="100%"
					height="100%"
					src={videoLink}
					allowFullScreen
					mozallowfullscreen="true"
					msallowfullscreen="true"
					oallowfullscreen="true"
					webkitallowfullscreen="true"
				></iframe>
			) : (
				<div>{errorMessage || 'loading....'}</div>
			)}
		</WrapperComponent>
	);
}

VideoPlayer.propTypes = {
	videoLink: PropTypes.string,
	errorMessage: PropTypes.string,
	CustomWrapper: PropTypes.elementType
};

VideoPlayer.defaultProps = {
	videoLink: '',
	errorMessage: '',
	CustomWrapper: React.Fragment
};

export default VideoPlayer;
